module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/village//result-bottom_bg.png?v=4642dc6a";